import Dexie from "dexie";

const db = new Dexie("OUG_Ticketing");

db.version(12).stores({
  people: "++id",
  currentState: "++id",
  tickets: "++id",
});

// check for a currentState DataObject
db.currentState
  .where("id")
  .equals(1)
  .toArray((result) => loadInitialState(result));

export default db;

function loadInitialState(result) {
  // If result is not an array ( no record found for id = 1) otherwise add it
  if (!result[0]) {
    db.currentState.add({
      id: 1,
    });
  }
}

export async function saveDexie(params) {
  if (params.action == "Update") {
    switch (params.desc) {
      case "games":
        await db.games.update(params.key, params.ele);
        break;
      case "people":
        await db.people.update(params.key, params.ele);
        break;
      case "cart":
        await db.cart.update(params.key, params.ele);
        break;
      case "cart_items":
        await db.cart_items.update(params.key, params.ele);
        break;
    }
  } else {
    switch (params.desc) {
      case "games":
        await db.games.put(params.ele);
        break;
      case "people":
        await db.people.put(params.ele);
        break;
      case "cart":
        await db.cart.put(params.ele);
        break;
      case "cart_items":
        await db.cart_items.put(params.ele);
        break;
    }
  }
}

export function compareValues(key, order = "asc") {
  return function innerSort(a, b) {
    // if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
    //     return 0;
    // }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
}
